import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-invite',
  templateUrl: './modal-invite.component.html',
  styleUrls: ['./modal-invite.component.scss']
})
export class ModalInviteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
